import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "./pages/LandingPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import CgvPage from "./pages/CgvPage";
import PolitiqueConfidentialitePage from "./pages/PolitiqueConfidentialitePage";

/** Forcer des href absolues : les chemins relatifs vers favicon se cassent sur /cgv, etc. */
function useFavicon() {
  useEffect(() => {
    const base = new URL(process.env.PUBLIC_URL || "/", window.location.origin);
    for (const link of document.querySelectorAll("head link[rel~='icon']")) {
      const h = link.getAttribute("href") || "";
      const t = (link.getAttribute("type") || "").toLowerCase();
      if (t.includes("svg") || h.includes("favicon.svg")) {
        link.setAttribute("href", new URL("favicon.svg", base).toString());
        continue;
      }
      if (t.includes("png") || h.includes("favicon-32x32") || h.includes("png")) {
        link.setAttribute("href", new URL("favicon-32x32.png", base).toString());
        continue;
      }
      link.setAttribute("href", new URL("favicon.ico", base).toString());
    }
    for (const link of document.querySelectorAll("head link[rel='apple-touch-icon']")) {
      const h = link.getAttribute("href") || "";
      if (h.includes("favicon") || h.includes("32x32")) {
        link.setAttribute("href", new URL("favicon-32x32.png", base).toString());
      }
    }
  }, []);
}

function App() {
  useFavicon();
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          <Route path="/cgv" element={<CgvPage />} />
          <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialitePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
